<template>
    <div>
      <Row>
        <Col :span="12">
          <Row>
            <Form inline :label-width="90" class="basicForm" ref="searchForm" :model="searchForm">
              <FormItem class="form-item" label="时间">
                <DatePicker type="datetime" placeholder="选择起始时间" v-model="searchForm.startDate" clearable class="width150" format="yyyy-MM-dd HH:mm" />
              </FormItem>
              <div class="splitLine"></div>
              <FormItem class="form-item" label="" :label-width="0" style="width: 150px">
                <DatePicker type="datetime" placeholder="选择结束时间" v-model="searchForm.endDate" clearable class="width150" format="yyyy-MM-dd HH:mm" />
              </FormItem>
              <!--<FormItem class="form-item" label="工序">
                <Select v-model="searchForm.type" clearable  class="width160"  placeholder="请选择" @on-change="searchBtn">
                  <Option v-for="item in processData" :value="item.id" :key="item.id" :label="item.name"></Option>
                </Select>
              </FormItem>-->
              <FormItem class="form-item form-item-button" label="" :label-width="0" style="width: 200px">
                <Button class="iconfont queryButton" type="primary" @click="searchBtn" :loading="loading">&nbsp;查询</Button>
              </FormItem>

            </Form>
          </Row>
          <Row class="marginTop20">
            <Table class="table" border :data="tableData" :columns="tableColumns" :loading="loading" highlight-row stripe >
            </Table>
            <!--
                        <Page :current="pageNum" :page-size="pageSize" :total="total" @on-change="handleChangePage" @on-page-size-change="handlePageSizeChange" show-total show-sizer style="margin-top:10px;text-align: center;" />
            -->
          </Row>
        </Col>
      </Row>

    </div>
</template>

<script>
    import {formatDate} from "@/api/util";
    import {getOverallList} from '@/api/index'
    export default {
        name: "processProgress",
        data(){
          return {
            processData:[],
            searchForm:{},
            tableData:[],
            loading:false,
            tableColumns:[
              {
                title: "序号",
                type: "index",
                width: 70,
                align: "center"
              },
              {
                key: "name",
                title: "工序",
                align: "center",
              },
              {
                key: "complete",
                title: "已完成",
                align: "center",
              },
              {
                key: "noComplete",
                title: "未完成",
                align: "center",
              },
              {
                key: "rate",
                title: "进度",
                align: "center",
                render:(h,params)=> {
                  let data = params.row.rate + '%';
                  return h("span", data);
                }
              },
            ],

          }
        },
      methods:{
        searchBtn(){
          this.tableData = []
          let params = {
            ...this.searchForm,
            startTime:this.searchForm.startDate ?
              formatDate(this.searchForm.startDate, "yyyy-MM-dd hh:mm:ss") : "",
            endTime:this.searchForm.endDate ?
              formatDate(this.searchForm.endDate, "yyyy-MM-dd hh:mm:ss") : "",
          }
          getOverallList(params)
            .then(res => {
              if(res.code == 200){
                  this.tableData = res.data;
              }
            })
        },
        init() {
          // 初始化时间为当天
          let eTime = new Date();
          eTime.setHours("23");
          eTime.setMinutes("59");
          eTime.setSeconds("59");
          this.searchForm.endDate = eTime;
          let newTime = new Date();
          newTime.setHours("00");
          newTime.setMinutes("00");
          newTime.setSeconds("00");
          this.searchForm.startDate = newTime;

        },
      },
      mounted() {
          this.init()
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/processProgress.vue